import _ from 'lodash';

const formField = {
  label: 'Indirizzo',
  name: 'address',
  type: 'location',
  placeholder: 'via, civico, città',
  initialValue: '',
  country: 'it',
};

const formFieldsItems = {};

formFieldsItems.route = {
  label: 'Via',
  name: 'address.route',
  initialValue: '',
  type: 'text',
  locationField: 'route',
};

formFieldsItems.street_number = {
  label: 'Civico',
  name: 'address.street_number',
  initialValue: '',
  type: 'text',
  locationField: 'street_number',
  isRequired: true,
};

formFieldsItems.city = {
  label: 'Città',
  name: 'address.city',
  initialValue: '',
  type: 'text',
  locationField: 'locality',
};

formFieldsItems.country = {
  label: 'Paese',
  name: 'address.country',
  initialValue: '',
  type: 'text',
  locationField: 'country',
};

formFieldsItems.latitude = {
  label: 'Latitudine', // non visualizzato come label, serve solo per la visualizzazione del messaggio d'errore
  name: 'location.latitude',
  initialValue: '',
  format: 'number',
  type: 'text',
  locationField: 'lat',
};

formFieldsItems.longitude = {
  label: 'Longitudine', // non visualizzato come label, serve solo per la visualizzazione del messaggio d'errore
  name: 'location.longitude',
  initialValue: '',
  format: 'number',
  type: 'text',
  locationField: 'lng',
};


const getConfig = (initialLocation, initialAddress) => {
  const field = { ...formField };
  let items = { ...formFieldsItems };

  if (initialLocation && initialAddress) {
    items = _.mergeWith(items, initialAddress, (src, dst) => ({
      ...src,
      initialValue: dst,
    }));

    field.initialValue = initialLocation.description;

    // coordinates
    items.latitude.initialValue = initialLocation.geometry.location.lat;
    items.longitude.initialValue = initialLocation.geometry.location.lng;
  }
  field.items = _.values(items);
  return [field];
};

export default {
  getConfig,
};



// WEBPACK FOOTER //
// ./src/lib/address-form-helpers.js